module.exports = __webpack_public_path__ + "static/media/4.e9add17f.JPG";